<template>
  <div class="assignment-detail">
    <BaseTitle :title="$t('content.assignment_detail')" :yearPeriode="titleData" />

    <v-progress-circular class="text-center" v-if="loadingLoader === true" indeterminate color="primary"></v-progress-circular>
    <template v-if="detailStudent">
      <v-card class="pa-6 mb-5">
        <header class="d-flex align-center assignment-detail-title">
          <div class="assignment-detail-icon">
            <svg-icon icon="assigment-ic" />
          </div>
          <div>
            <h2 class="app-section-title">{{ detailData.assignmentTitle }}</h2>
            <div style="color:#CE8800;">{{ $t('content.by') }}: {{ detailData.teacherName }}</div>
          </div>
          <v-spacer />
          <div></div>
          <div style="width: 500px" class="mr-3 ml-3">
            <div class="d-flex align-center">
              <strong v-if="detailData.assignmentTypeId === 1" class="text-no-wrap">
                {{ $t('content.upload_here') }}
              </strong>
              <form-group
                v-if="detailData.assignmentTypeId === 1"
                :name="$t('form.file')"
                :validator="$v.form.file"
                no-gutter
                style="width: 100%; max-width: 250px;"
                class="mx-3"
              >
                <template slot-scope="{ attrs }">
                  <v-file-input
                    :label="$t('form.file')"
                    accept=".jpg,.jpeg,.png,.pdf,.mp4,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.mp3,.sb3"
                    chips
                    show-size
                    v-bind="attrs"
                    small-chips
                    v-model="form.file"
                    truncate-length="15"
                    @input="$v.form.file.$touch()"
                    @blur="$v.form.file.$touch()"
                  ></v-file-input>
                </template>
              </form-group>
              <v-btn
                color="primary btn-primary-custom"
                v-if="
                  (detailData.attempt && detailData.assignmentTypeId == 1 && detailData.published === false) ||
                    (detailData.attempt === null && detailData.assignmentTypeId == 1 && detailData.published === false)
                "
                @click="submit"
                :loading="loading"
                >{{ $t('submit') }}</v-btn
              >
            </div>
            <p style="color: red; font-size: 12px;">
              <b>{{ $t('content.character_not_allowed') }}:</b>
              ! @ # $ % ^ &amp; * ( ) + = { } [ ] : ; &quot; &#39; &lt; &gt; , ? / \ ~ `
            </p>
          </div>

          <v-btn
            color="primary btn-primary-custom"
            v-if="
              (detailData.attempt === 0 && detailData.assignmentTypeId === 1) ||
                (detailData.published === true && detailData.assignmentTypeId === 1) ||
                (detailData.lock === true && detailData.assignmentTypeId == 1)
            "
            @click="dialogPopUp = true"
            >{{ $t('submit') }}</v-btn
          >

          <v-btn
            color="primary btn-primary-custom"
            v-if="
              (detailData.attempt && detailData.assignmentTypeId == 2 && detailData.published === false) ||
                (detailData.attempt === null && detailData.assignmentTypeId == 2 && detailData.published === false)
            "
            @click="dialogTakeQuiz = true"
            >{{ $t('content.take_quiz') }}</v-btn
          >

          <v-btn
            color="primary btn-primary-custom"
            v-if="
              (detailData.attempt === 0 && detailData.assignmentTypeId === 2) ||
                (detailData.published === true && detailData.assignmentTypeId === 2) ||
                (detailData.lock === true && detailData.assignmentTypeId == 2)
            "
            @click="dialogPopUp = true"
            >{{ $t('content.take_quiz') }}</v-btn
          >

          <!-- Dialog Take Quiz -->
          <v-dialog v-model="dialogTakeQuiz" persistent max-width="600">
            <v-card>
              <v-card-title class="headline">{{ $t('content.quiz_take_title') }} ?</v-card-title>
              <v-card-text>{{ $t('content.quiz_take_content') }}</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text :disabled="dialogLambda" @click="dialogTakeQuiz = false">{{ $t('disagree') }}</v-btn>
                <v-btn text :disabled="dialogLambda" :loading="dialogLambda" @click="takeQuiz(detailData.timeLimit)">{{ $t('aggree') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogLambda" hide-overlay persistent width="300">
            <v-card color="primary" dark>
              <v-card-text>
                Please stand by
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
        </header>
        <div class="assignment-detail-desc">
          <strong>{{ $t('form.desc') }}</strong>
          <p class=" mb-5" v-if="!detailData.description">-</p>
          <article v-else class="container mb-5" v-html="detailData.description" />
          <v-row
            v-if="
              (detailData.attempt === 0 && detailData.assignmentTypeId == 1) ||
                (detailData.attempt === 0 && detailData.assignmentTypeId == 2) ||
                (detailData.attempt && detailData.assignmentTypeId == 1) ||
                (detailData.attempt && detailData.assignmentTypeId == 2) ||
                (detailData.attempt === null && detailData.assignmentTypeId == 1) ||
                (detailData.attempt === null && detailData.assignmentTypeId == 2)
            "
          >
            <v-col md="2">
              <div
                v-if="
                  (detailData.attempt === 0 && detailData.assignmentTypeId == 1) ||
                    (detailData.attempt === 0 && detailData.assignmentTypeId == 2) ||
                    (detailData.attempt && detailData.assignmentTypeId == 1) ||
                    (detailData.attempt && detailData.assignmentTypeId == 2)
                "
              >
                <span class="d-block">{{ $t('content.attempt_remaining') }}</span>
                <strong>{{ detailData.attempt }} / {{ detailData.totalAttempt }} </strong>
              </div>
              <div
                v-if="
                  (detailData.attempt === null && detailData.assignmentTypeId == 1) ||
                    (detailData.attempt === null && detailData.assignmentTypeId == 2)
                "
              >
                <span class="d-block">{{ $t('content.attempt_remaining') }}</span>
                <strong>{{ $t('content.unlimited') }} </strong>
              </div>
            </v-col>

            <v-col md="2">
              <div>
                <span class="d-block">{{ $t('content.file_teacher') }}</span>
                <a href="javascript:(0)" v-if="teacherFile" @click.prevent="previewFileTeacher(undefined, { teacherFile })"
                  >{{ teacherFile.fileName }}.{{ teacherFile.extension }}</a
                >
                <span v-if="!teacherFile">-</span>
              </div>
            </v-col>
            <v-col md="2">
              <div>
                <span class="d-block">{{ $t('content.available_from') }}</span>
                <strong style="color:#00BF63;" v-if="detailData.availableFromDate">{{ detailData.availableFromDate }}</strong>
                <strong style="color:#00BF63;" v-if="!detailData.availableFromDate">-</strong>
              </div></v-col
            >

            <v-col md="2">
              <div>
                <span class="d-block">{{ $t('content.due_date') }}</span>
                <strong style="color:#FA6400;">{{ detailData.dueDate }}</strong>
                <strong style="color:#E02020;" v-if="!detailData.dueDate">-</strong>
              </div></v-col
            >

            <v-col md="2">
              <div>
                <span class="d-block">{{ $t('content.assignment_type') }}</span>
                <strong v-if="detailData.assignmentTypeId == 4">{{ $t('content.assignment_item.manual_input') }} </strong>
                <strong v-if="detailData.assignmentTypeId == 3">{{ $t('content.assignment_item.attendance') }}</strong>
                <strong v-if="detailData.assignmentTypeId == 2">{{ $t('content.assignment_item.quiz') }}</strong>
                <strong v-if="detailData.assignmentTypeId == 1">{{ $t('content.assignment_item.upload_files') }}</strong>
              </div></v-col
            >
            <v-col md="2">
              <div>
                <span class="d-block">{{ $t('menu.score') }}</span>
                <strong v-if="(detailData.score === 0 && detailData.published === false) || detailData.excused"
                  >0 / {{ detailData.totalScore }}</strong
                >
                <strong v-else>{{ detailData.score }} / {{ detailData.totalScore }} </strong>
              </div></v-col
            >
          </v-row>
          <v-row v-else>
            <v-col md="3">
              <div>
                <span class="d-block">{{ $t('content.file_teacher') }}</span>
                <a href="javascript:(0)" v-if="teacherFile" @click.prevent="previewFileTeacher(undefined, { teacherFile })"
                  >{{ teacherFile.fileName }}.{{ teacherFile.extension }}</a
                >
                <span v-if="!teacherFile">-</span>
              </div>
            </v-col>

            <v-col md="3">
              <div>
                <span class="d-block">{{ $t('content.due_date') }}</span>
                <strong style="color:#FA6400;">{{ detailData.dueDate }}</strong>
                <strong style="color:#E02020;" v-if="!detailData.dueDate">-</strong>
              </div></v-col
            >

            <v-col md="3">
              <div>
                <span class="d-block">{{ $t('content.assignment_type') }}</span>
                <strong v-if="detailData.assignmentTypeId == 4">{{ $t('content.assignment_item.manual_input') }} </strong>
                <strong v-if="detailData.assignmentTypeId == 3">{{ $t('content.assignment_item.attendance') }}</strong>
                <strong v-if="detailData.assignmentTypeId == 2">{{ $t('content.assignment_item.quiz') }}</strong>
                <strong v-if="detailData.assignmentTypeId == 1">{{ $t('content.assignment_item.upload_files') }}</strong>
              </div></v-col
            >
            <v-col md="3">
              <div>
                <span class="d-block">{{ $t('menu.score') }}</span>
                <strong v-if="(detailData.score === 0 && detailData.published === false) || detailData.excused"
                  >- / {{ detailData.totalScore }}
                </strong>
                <strong v-else>{{ detailData.score }} / {{ detailData.totalScore }} </strong>
              </div></v-col
            >
          </v-row>
        </div>
      </v-card>
      <v-row v-if="detailData.assignmentTypeId == 1">
        <v-col md="6" v-for="submissionDetails in detailData.submissionDetails" v-bind:key="submissionDetails.submissionId">
          <v-card class="pa-6">
            <header class="assignment-detail-title">
              <h2 class="app-section-title">{{ $t('content.submission_detail') }}</h2>
            </header>
            <div class="d-flex mb-4">
              <div>
                <span class="d-block">{{ $t('content.submitted') }}</span>
                <strong class="teal--text text--lighten-2">{{ submissionDetails.submittedAt }}</strong>
              </div>
              <v-spacer />

              <div>
                <span class="d-block">{{ $t('information') }}</span>
                <strong class="red--text" v-if="submissionDetails.late == true">{{ $t('content.attendance_item.late') }}</strong>

                <strong class="green--text" v-if="submissionDetails.late == false">{{ $t('content.on_time') }}</strong>
              </div>
            </div>
            <div class="d-flex mb-4">
              <div>
                <span class="d-block">{{ $t('content.submission_file') }}</span>
                <!-- <a :href="linkDownload" download>{{ submissionDetails.submissionName }}.{{ submissionDetails.extension }}</a> -->

                <a href="javascript:(0)" @click.prevent="previewFile(undefined, { submissionDetails })"
                  >{{ submissionDetails.submissionName }}.{{ submissionDetails.extension }}</a
                >
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col md="6" v-if="detailData.comment">
          <v-card class="pa-6">
            <header class="assignment-detail-title">
              <h2 class="app-section-title">{{ $t('content.comments') }}</h2>
            </header>
            <div class="d-flex">
              <v-list-item-avatar>
                <v-img v-if="!detailData.comment.imageUrl" :src="require('@/assets/images/sample-user.png')"></v-img>
                <v-img v-if="detailData.comment.imageUrl" :src="detailData.comment.imageUrl"></v-img>
              </v-list-item-avatar>
              <div class="ml-3">
                <strong class="d-block mb-4" v-if="detailData.comment.teacherName">{{ detailData.comment.teacherName }}</strong>
                <strong class="d-block mb-4" v-if="!detailData.comment.teacherName">-</strong>
                <article v-if="detailData.comment.comment" v-html="detailData.comment.comment" />

                <span v-if="!detailData.comment.comment">-</span>
              </div>
            </div>
          </v-card>
        </v-col>
        <!-- Dialog Alert Attempt -->
        <!-- <v-dialog v-model="dialogPopUp" persistent max-width="607">
          <v-card>
            <div class="d-flex justify-center">
              <svg-icon icon="ic-failed" width="180" height="121" class="mt-5 mb-5" />
            </div>
            <v-card-title class="headline d-flex justify-center" v-if="detailData.published === false || detailData.lock === false"
              >{{ $t('content.attempt_title') }}
            </v-card-title>
            <v-card-title class="headline d-flex justify-center" v-if="detailData.published === true || detailData.lock === true"
              >{{ $t('content.assignment_close1') }}
            </v-card-title>
            <v-card-text class="d-flex justify-center" v-if="detailData.published === false || detailData.lock === false"
              >{{ $t('content.attempt_body') }}
            </v-card-text>
            <v-card-text class="d-flex justify-center" v-if="detailData.published === true || detailData.lock === true"
              >{{ $t('content.assignment_close') }}
            </v-card-text>
            <v-card-text class="d-flex justify-center">
              <v-btn color="primary" class="btn-primary-custom" @click="dialogPopUp = false">
                {{ $t('content.attempt_button') }}
              </v-btn>
            </v-card-text>
          </v-card>
        </v-dialog> -->
        <v-dialog v-model="dialogPopUp" persistent max-width="607">
          <v-card>
            <div class="d-flex justify-center">
              <svg-icon icon="ic-failed" width="180" height="121" class="mt-5 mb-5" />
            </div>
            <v-card-title class="headline d-flex justify-center" v-if="detailData.published === false"
              >{{ $t('content.attempt_title') }}
            </v-card-title>
            <v-card-title class="headline d-flex justify-center" v-if="detailData.published === true && detailData.assignmentTypeId == 1"
              >{{ $t('content.assignment_close1') }}
            </v-card-title>
            <v-card-title class="headline d-flex justify-center" v-if="detailData.published === true && detailData.assignmentTypeId == 2"
              >{{ $t('content.assignment_close12') }}
            </v-card-title>
            <v-card-text class="d-flex justify-center" v-if="detailData.published === false">{{ $t('content.attempt_body') }} </v-card-text>
            <v-card-text class="d-flex justify-center" v-if="detailData.published === true">{{ $t('content.assignment_close') }} </v-card-text>
            <v-card-text class="d-flex justify-center">
              <v-btn color="primary" class="btn-primary-custom" @click="dialogPopUp = false">
                {{ $t('content.attempt_button') }}
              </v-btn>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
      <v-row v-if="detailData.assignmentTypeId == 2">
        <v-col md="9">
          <v-card class="pa-6">
            <header class="assignment-detail-title">
              <h2 class="app-section-title">{{ $t('content.submission_detail') }}</h2>
            </header>
            <v-data-table :headers="tableHeader" :items="detailData.submissionDetails" disable-pagination hide-default-footer class="table-custom">
              <template v-slot:item.submissionName="{ item }">
                <div v-if="item.selected === true && detailData.published === true">
                  {{ item.submissionName }}<span class="text-caption green--text ml-2" style="font-size:5em;">{{ $t('form.selected') }}</span>
                </div>
                <span v-else>{{ item.submissionName }}</span>
              </template>
              <template v-slot:item.late="{ item }">
                <b>
                  <span v-if="item.late === true" class="red--text">{{ $t('content.attendance_item.late') }}</span>
                  <span v-if="item.late === false" class="green--text">{{ $t('content.on_time') }}</span>
                </b>
              </template>
              <template #no-data>{{ $t('data_not_available') }}</template>
            </v-data-table>
            <div class="d-flex justify-end align-center" v-if="detailData.published === true">
              <v-btn
                color="primary"
                v-for="submissionDetails in detailData.submissionDetails.filter(form => form.selected === true)"
                :key="submissionDetails.submissionId"
                class="btn-primary-custom mt-5"
                type="submit"
                @click="viewAnswer(submissionDetails)"
              >
                {{ $t('content.view_detail_answer') }}
              </v-btn>
            </div>
          </v-card>
        </v-col>
        <v-col md="3" v-if="detailData.comment">
          <v-card class="pa-6" v-if="detailData.comment">
            <header class="assignment-detail-title">
              <h2 class="app-section-title">{{ $t('content.comments') }}</h2>
            </header>
            <div class="d-flex">
              <v-list-item-avatar>
                <v-img v-if="!detailData.comment.imageUrl" :src="require('@/assets/images/sample-user.png')"></v-img>
                <v-img v-if="detailData.comment.imageUrl" :src="detailData.comment.imageUrl"></v-img>
              </v-list-item-avatar>
              <div class="ml-3">
                <strong class="d-block mb-4" v-if="detailData.comment.teacherName">{{ detailData.comment.teacherName }}</strong>
                <strong class="d-block mb-4" v-if="!detailData.comment.teacherName">-</strong>
                <span v-if="detailData.comment.comment">{{ detailData.comment.comment }}</span>
                <span v-if="!detailData.comment.comment">-</span>
              </div>
            </div>
          </v-card>
        </v-col>

        <!-- Dialog Alert Attempt -->
        <!-- <v-dialog v-model="dialogPopUp" persistent max-width="607">
          <v-card>
            <div class="d-flex justify-center">
              <svg-icon icon="ic-failed" width="180" height="121" class="mt-5 mb-5" />
            </div>
            <v-card-title class="headline d-flex justify-center" v-if="detailData.published === false || detailData.lock === false"
              >{{ $t('content.attempt_title') }}
            </v-card-title>
            <v-card-title class="headline d-flex justify-center" v-if="detailData.published === true || detailData.lock === true"
              >{{ $t('content.assignment_close1') }}
            </v-card-title>
            <v-card-text class="d-flex justify-center" v-if="detailData.published === false || detailData.lock === false"
              >{{ $t('content.attempt_body') }}
            </v-card-text>
            <v-card-text class="d-flex justify-center" v-if="detailData.published === true || detailData.lock === true"
              >{{ $t('content.assignment_close') }}
            </v-card-text>
            <v-card-text class="d-flex justify-center">
              <v-btn color="primary" class="btn-primary-custom" @click="dialogPopUp = false">
                {{ $t('content.attempt_button') }}
              </v-btn>
            </v-card-text>
          </v-card>
        </v-dialog> -->
        <v-dialog v-model="dialogPopUp" persistent max-width="607">
          <v-card>
            <div class="d-flex justify-center">
              <svg-icon icon="ic-failed" width="180" height="121" class="mt-5 mb-5" />
            </div>
            <v-card-title class="headline d-flex justify-center" v-if="detailData.published === false"
              >{{ $t('content.attempt_title') }}
            </v-card-title>
            <v-card-title class="headline d-flex justify-center" v-if="detailData.published === true && detailData.assignmentTypeId == 1"
              >{{ $t('content.assignment_close1') }}
            </v-card-title>
            <v-card-title class="headline d-flex justify-center" v-if="detailData.published === true && detailData.assignmentTypeId == 2"
              >{{ $t('content.assignment_close12') }}
            </v-card-title>
            <v-card-text class="d-flex justify-center" v-if="detailData.published === false">{{ $t('content.attempt_body') }} </v-card-text>
            <v-card-text class="d-flex justify-center" v-if="detailData.published === true">{{ $t('content.assignment_close') }} </v-card-text>
            <v-card-text class="d-flex justify-center">
              <v-btn color="primary" class="btn-primary-custom" @click="dialogPopUp = false">
                {{ $t('content.attempt_button') }}
              </v-btn>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
      <!-- File Viewer -->
      <file-viewer :data="preview" v-model="dialogPreview" @onHide="hidePreview" />
    </template>
    <template v-if="!detailStudent">
      <div class="succ">
        <div class="succ-content">
          <svg-icon icon="ic-nodata-mini" class="succ-featured" width="130" height="100" />
          <h1 class="succ-heading">{{ $t('nodata_title') }}</h1>
          <div class="succ-content mb-8">{{ $t('nodata_body') }}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import { required } from 'vuelidate/lib/validators';
import { fileSize, fileType } from '@/validators';
import FileViewer from '@/components/FileViewer';

const extAllowed = ['mp4', 'mp3', 'pptx', 'ppt', 'doc', 'docx', 'xls', 'xlsx', 'pdf', 'jpg', 'png', 'jpeg', 'sb3'];

export default {
  name: 'AssignmentDetail',
  components: {
    BaseTitle,
    FileViewer
  },
  computed: {
    ...mapGetters({
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    }),
    teacherFile() {
      if (this.detailData.descriptionFile) {
        return this.detailData.descriptionFile;
      } else {
        return null;
      }
    },
    linkDownload() {
      return `${this.baseUrl}/api/file/download?key=${this.detailData.submissionDetails[0].key}`;
    },
    tableHeader() {
      return [
        { text: this.$t('content.attempt'), value: 'submissionName', sortable: false },
        { text: this.$t('content.submitted'), value: 'submittedAt', sortable: false },
        { text: this.$t('information'), value: 'late', sortable: false }
      ];
    }
  },
  sockets: {
    connect() {
      console.log('socket connected');
    },
    updateDetailAssignment({ classId, courseId, assignmentId }) {
      const { classId: currentClassId, courseId: currentCourseId, assignmentId: currentAssignmentId } = this.$route.params;
      if (classId == currentClassId && courseId == currentCourseId && assignmentId == currentAssignmentId) {
        this.$store.dispatch('general/showSuccessNotification', { message: this.$t('alert.list_assignment') });
        setTimeout(() => {
          var backModules = localStorage.getItem('backModules');
          if (!backModules) {
            this.$router.push({ name: 'StudentAssignment' });
          } else {
            this.$router.back();
          }
          // this.getData(this.$route.params.assignmentId);
        }, 400);
      }
    }
  },
  validations() {
    return {
      form: {
        file: {
          required,
          fileSize: fileSize(500),
          fileType: fileType(extAllowed)
        }
      }
    };
  },
  data: () => ({
    dialogTakeQuiz: false,
    baseUrl: process.env.VUE_APP_BASE_URL,
    dataClass: '',
    detailStudent: localStorage.getItem('detailStudent'),
    id: null,
    attempt: '',
    dialogPopUp: false,
    loading: false,
    loadingLoader: false,
    form: {
      fileName: null,
      file: null
    },
    dataFile: '',
    detailData: {},
    dialogPreview: false,
    preview: {},
    dialogLambda: false,
    titleData: ''
  }),
  methods: {
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    getData(id) {
      this.loadingLoader = true;
      this.$store
        .dispatch('Assignment/fetchDetailStudent', id)
        .then(res => {
          if (res.autoLock === true && res.attempt === 0) {
            setTimeout(() => {
              var backModules = localStorage.getItem('backModules');
              if (!backModules) {
                // this.$router.push({ name: 'StudentAssignment' });
              } else {
                this.$router.back();
              }
              // this.getData(this.$route.params.assignmentId);
            }, 400);
          }
          this.detailData = res;
          this.id = res.id;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loadingLoader = false));
    },
    // File Viewer Student
    previewFile(e, { submissionDetails }) {
      this.dialogPreview = true;
      this.$set(this, 'preview', submissionDetails);
    },
    // File Viewer Teacher
    previewFileTeacher(e, { teacherFile }) {
      this.dialogPreview = true;
      this.$set(this, 'preview', teacherFile);
    },
    hidePreview() {
      this.dialogPreview = null;
      this.$set(this, 'preview', {});
    },
    takeQuiz(item) {
      this.dialogLambda = true;
      this.dialogTakeQuiz = false;
      var assignmentId = this.$route.params.assignmentId;
      this.$store
        .dispatch('Assignment/hitLambda', { assignmentId })
        .then(() => {
          localStorage.removeItem('timeQuiz');
          if (!localStorage.getItem('timeQuiz') || localStorage.getItem('timeQuiz') === '-1') {
            if (item) {
              var timelimit = item * 60;
              localStorage.setItem('timeQuiz', timelimit);
            } else {
              localStorage.setItem('timeQuiz', null);
            }
          }
          this.$router.push({ name: 'StudentAssignmentScoreQuiz' });
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.dialogLambda = false));
    },
    // getFile(id) {
    //   this.$store
    //     .dispatch('Assignment/getFile', id)
    //     .then(res => {
    //       this.dataFile = res;
    //     })
    //     .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    // },
    viewAnswer({ submissionId }) {
      this.$router.push({ name: 'StudentAssignmentDetailQuiz', params: { submissionId } });
      // console.info(item);
    },
    submit() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) return false;

      this.loading = true;

      var fpath = this.form.file.name;

      fpath = fpath.replace(/\\/g, '/');

      var fname = fpath.substring(fpath.lastIndexOf('/') + 1, fpath.lastIndexOf('.'));

      if (/^[a-zA-Z0-9|.| |_|-]*$/i.test(fname)) {
        this.form.fileName = fname;

        var assignmentId = this.$route.params.assignmentId;
        this.$store
          .dispatch('Assignment/uploadFile', { assignmentId, ...this.form })
          .then(({ data }) => {
            this.$store.dispatch('general/showSuccessNotification', data);
            this.form.file = null;
            this.attempt = data.attempt;
            this.getData(assignmentId);
            this.$v.$reset();
            // this.getFile(assignmentId);
          })
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
          .finally(() => {
            if (localStorage.getItem('backModules')) {
              this.$router.back();
            }
            this.loading = false;
          });
      } else {
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('content.word_upload') });

        this.loading = false;
      }
    }
  },
  created() {
    this.getDataClass();
    if (this.$route.params.assignmentId) {
      this.getData(this.$route.params.assignmentId);
      // this.getFile(this.$route.params.assignmentId);
    }
  }
};
</script>

<style lang="scss" scoped>
.assignment-detail {
  &-title {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #acacac;
  }

  &-icon {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    background: #fff0da;
    color: #f1b65a;
    box-sizing: border-box;
    text-align: center;
    margin-right: 16px;

    svg {
      transform: scale(1.6);
      margin-top: 15px;
    }
  }

  &-desc {
    line-height: 1.8em;
    padding-left: 65px;
  }
}
.succ {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: Montserrat;
  font-weight: 500;

  &-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px;
    font-size: 12px;
  }

  &-featured {
    width: 100%;
    margin-bottom: 30px;
  }

  &-heading {
    color: #6d6d6d;
    font-family: Montserrat;
    font-weight: bold;
    font-size: 16px;
  }
}
</style>
